import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import ClientDetailsClientGrantsPage from "./pages/ClientGrant";
import ClientDetailsGrantsPage from "./pages/ClientGrants";
import { ClientDetailsList } from "./pages/Index";
import { ClientDetailsImportContext } from "./services/types";

interface Props extends RouteComponentProps {
	requests: ClientDetailsImportContext;
}

const ClientDetailsPage = (props: Props) => {
	return (
		<Switch>
			<Route path={`${props.match.url}/`} exact render={() => <ClientDetailsList requests={props.requests} />} />
			<Route
				path={`${props.match.url}/client_grants`}
				render={() => <ClientDetailsGrantsPage requests={props.requests} />}
			/>
			<Route
				path={`${props.match.url}/:clientId/client_grants`}
				render={() => <ClientDetailsClientGrantsPage requests={props.requests} />}
			/>
		</Switch>
	);
};

export default ClientDetailsPage;
